import React from 'react';

// =============================================================================
// Inbox-provenance badge (CTR-016 / REQ-011 / AC-U-009).
//
// Renders when a row's `source_reference` matches `^inbox_resolution:` — the
// marker set by TaxWriteApiHandler when a manual transaction or manual tax lot
// is created via the combined inbox-resolution endpoint (AD-7).
//
// Marker format (from TASK-009): `inbox_resolution:{portfolioId}:{sourceIdentifier}`.
// The tooltip exposes the parsed `(portfolioId, sourceIdentifier)` tuple so the
// operator can trace the row back to its inbox origin.
//
// Reuses the canonical `.badge` / `.badge-status` chrome — no new style namespace.
// =============================================================================

const MARKER_PREFIX = 'inbox_resolution:';

export const InboxProvenanceBadge: React.FC<{ sourceReference?: string | null }> = ({
  sourceReference,
}) => {
  if (!sourceReference || !sourceReference.startsWith(MARKER_PREFIX)) {
    return null;
  }
  const rest = sourceReference.substring(MARKER_PREFIX.length);
  // Split on the first ':' so source identifiers containing ':' survive.
  const firstColon = rest.indexOf(':');
  const portfolioId = firstColon >= 0 ? rest.substring(0, firstColon) : rest;
  const sourceIdentifier = firstColon >= 0 ? rest.substring(firstColon + 1) : '';
  const tooltip = `(${portfolioId}, ${sourceIdentifier})`;
  return (
    <span className="badge badge-status" title={tooltip}>
      Inbox-resolved
    </span>
  );
};

export default InboxProvenanceBadge;
